import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { presetMessages } from '../../../services/reducers/pharmacy/sms/smsPresetSlice';

const PresetMessageDialog = ({ isOpen, onClose, onSelectMessage }) => {
    const dispatch = useDispatch();
    const presets = useSelector((state) => state.smsPreset?.smsPreset?.presets?.data || []);
    const isLoadingPresets = useSelector((state) => state.smsPreset?.smsPreset?.loading);

    // Fetch preset messages when the dialog opens
    useEffect(() => {
        if (isOpen && presets.length === 0) {
            dispatch(presetMessages());
        }
    }, [dispatch, isOpen, presets.length]);


    if (!isOpen) return null;

    // Filter messages to only include those with descriptions
    const presetList = Array.isArray(presets) ? presets : [];
    const filteredData = presetList.filter(item => item?.description);

    const handleMessageSelect = (message, description) => {
        onSelectMessage(message, description);
        onClose();
    };

    return (
        <div
            className="relative bg-white border border-gray-300 rounded-lg shadow-lg w-96 mx-auto"
            onClick={e => e.stopPropagation()}
        >
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h3 className="font-semibold text-lg text-gray-800">Select Preset Message</h3>
                <button
                    onClick={onClose}
                    className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>

            <div className="max-h-96 overflow-y-auto p-4">
                {isLoadingPresets ? (
                    <div className="flex justify-center py-4">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                ) : filteredData.length > 0 ? (
                    <ul className="space-y-2">
                        {filteredData.map((item, index) => (
                            <li
                                key={item.id || index}
                                onClick={() => handleMessageSelect(item.message, item.description)}
                                className="p-3 hover:bg-gray-50 rounded-lg cursor-pointer transition-colors border border-gray-100 hover:border-gray-200"
                            >
                                <p className="font-medium text-sm text-gray-700">{item.description}</p>
                                <p className="text-xs text-gray-500 mt-1 line-clamp-2">{item.message}</p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="text-center py-8">
                        <p className="text-gray-500">No preset messages available</p>
                    </div>
                )}
            </div>
        </div>

    );
};

export default PresetMessageDialog; 